var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBorderedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 19,
    rx: 3.5,
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.99023C13.835 6.82523 12.16 6.74023 10.49 6.74023C9.5 6.74023 8.51 6.79023 7.52 6.89023L6.5 6.99023",
    stroke: "#F3F3F3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 6.485L9.36 5.83C9.44 5.355 9.5 5 10.345 5H11.655C12.5 5 12.565 5.375 12.64 5.835L12.75 6.485",
    stroke: "#F3F3F3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4242 8.56982L14.0992 13.6048C14.0442 14.3898 13.9992 14.9998 12.6042 14.9998H9.39422C7.99922 14.9998 7.95422 14.3898 7.89922 13.6048L7.57422 8.56982",
    stroke: "#F3F3F3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1641 12.25H11.8291",
    stroke: "#F3F3F3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.25H12.25",
    stroke: "#F3F3F3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBorderedDark);
export default __webpack_public_path__ + "static/media/delete_bordered_dark.a8dfb1daabbf5e32bf6cbb0a7647c441.svg";
export { ForwardRef as ReactComponent };